import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaEnvelope, FaPhoneAlt, FaCalendarAlt } from 'react-icons/fa';

export default function DemoPopover({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center px-4"
          onClick={onClose}
        >
          {/* Backdrop */}
          <div className="absolute inset-0 bg-ink-900/40 backdrop-blur-sm" />

          {/* Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 16 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            className="relative z-10 w-full max-w-md bg-white rounded-3xl shadow-glass-lg p-8"
          >
            {/* Close */}
            <button
              onClick={onClose}
              className="absolute top-5 right-5 w-8 h-8 rounded-full bg-gray-100
                         flex items-center justify-center text-ink-400
                         hover:bg-gray-200 transition-colors"
            >
              <FaTimes />
            </button>

            {/* Icon */}
            <div className="w-12 h-12 rounded-2xl bg-brand-purple/10 flex items-center
                            justify-center text-brand-purple text-xl mb-5">
              <FaCalendarAlt />
            </div>

            <h2 className="font-display font-black text-2xl text-ink-900 mb-2">
              Book a Demo
            </h2>
            <p className="text-ink-500 text-sm leading-relaxed mb-7">
              Reach out to us and our team will get back to you within <strong>24 hours</strong> to
              schedule a personalised demo of the Placement ERP.
            </p>

            <div className="space-y-3">
              <a
                href="mailto:supportus@jobxbharat.com"
                className="flex items-center gap-4 p-4 rounded-2xl border border-gray-100
                           hover:border-brand-purple hover:bg-secondary-50 transition-all group"
              >
                <span className="w-9 h-9 rounded-xl bg-brand-purple/10 flex items-center
                                 justify-center text-brand-purple shrink-0">
                  <FaEnvelope />
                </span>
                <div>
                  <p className="text-xs text-ink-300 font-semibold uppercase tracking-wide">Email us</p>
                  <p className="text-sm font-black text-ink-900 group-hover:text-brand-purple transition-colors">
                    supportus@jobxbharat.com
                  </p>
                </div>
              </a>

              <a
                href="tel:+917002502224"
                className="flex items-center gap-4 p-4 rounded-2xl border border-gray-100
                           hover:border-brand-saffron hover:bg-orange-50 transition-all group"
              >
                <span className="w-9 h-9 rounded-xl bg-brand-saffron/10 flex items-center
                                 justify-center text-brand-saffron shrink-0">
                  <FaPhoneAlt />
                </span>
                <div>
                  <p className="text-xs text-ink-300 font-semibold uppercase tracking-wide">Call us</p>
                  <p className="text-sm font-black text-ink-900 group-hover:text-brand-saffron transition-colors">
                    +91 7002502224
                  </p>
                </div>
              </a>
            </div>

            <p className="mt-6 text-center text-xs text-ink-300">
              Mon – Fri · 10:00 AM – 6:00 PM IST
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
